import React, { useEffect } from 'react';
import { FormInputDropdown } from 'app/components/Candidate/CandidateProfile/CandidateTabPanel/PersonalInfoTab/Form/Controls/FormInputDropdown';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import {
  reimbursementCategoryId,
  reimbursementDescription,
  reimbursementDescriptionId,
} from 'app/models/Placement/PlacementMods';
import { isNullOrUndefined } from 'app/helpers/objectHelpers';
import { useDispatch, useSelector } from 'react-redux';
import { selectIsUndoModal } from 'store/redux-store/placement-mods/selectors';
import { placementModsAction } from 'store/redux-store/placement-mods/slice';
import { CategoryDescriptionOptions } from './ReimbursementHelper';

export const Description = ({ options, isModEdit }: { options: any; isModEdit: boolean }) => {
  const { control, setValue, clearErrors, getValues, setError } = useFormContext();
  const reimbursementDescriptionValue = useWatch<any>({ name: 'reimbursementCategoryDescriptionId' });
  const reimbursementCategoryValue = useWatch<any>({ name: reimbursementCategoryId });
  const descriptionOptions = options?.find(item => parseInt(item.ID) === reimbursementCategoryValue)?.descriptions;
  const isUndoModal = useSelector(selectIsUndoModal);
  const dispatch = useDispatch();
  let initialState = true;

  const isEditable = value => {
    if (isModEdit) {
      return ![
        CategoryDescriptionOptions.MiscellaneousCellPhoneStipend,
        CategoryDescriptionOptions.PerDiemCellPhoneStipend,
        CategoryDescriptionOptions.PerDiemHousingAmenities,
        CategoryDescriptionOptions.PerDiemMeal,
        CategoryDescriptionOptions.MiscellaneousCarAllowance,
        CategoryDescriptionOptions.MiscellaneousMealAllowance,
        CategoryDescriptionOptions.MiscellaneousShiftCompletionBonus
      ].includes(value);
    }
    return false;
  };

  const handleValueChanged = value => {
    setValue(reimbursementDescription, value);
    const selectedValue = descriptionOptions?.find(item => item.Description === value);
    setValue(
      reimbursementDescriptionId,
      selectedValue?.CategoryDescriptionId ? parseInt(selectedValue?.CategoryDescriptionId) : '',
    );
    if (value) {
      clearErrors(reimbursementDescription);
      clearErrors('initialDescription');
    }
    if (!isEditable(selectedValue?.CategoryDescriptionId)) {
      setValue('initialEndDate', null);
    }
    initialState = false;
  };

  useEffect(() => {
    const value = descriptionOptions?.find(
      item => parseInt(item.CategoryDescriptionId) === reimbursementDescriptionValue,
    )?.Description;
    setValue(reimbursementDescription, value ?? null);
    if (isModEdit && isNullOrUndefined(value) && initialState) {
      setError('initialDescription', {});
    }
    if (isUndoModal) {
      dispatch(placementModsAction.setIsUndoModal(false));
    }
  }, [descriptionOptions, isUndoModal]);

  return (
    <>
      <Controller
        control={control}
        rules={{
          required: isModEdit,
        }}
        name={reimbursementDescriptionId}
        render={({ field: { onChange, ...rest } }) => {
          return (
            <FormInputDropdown
              inputValue={getValues(reimbursementDescription) ?? null}
              disabledOptions={descriptionOptions && descriptionOptions.filter(x => !x.Active)}
              name={reimbursementDescription}
              label={`Description *`}
              require={true}
              standard={true}
              options={descriptionOptions?.length > 0 ? descriptionOptions : []}
              readOnly={!isModEdit}
              handleChange={e => {
                onChange(e);
                handleValueChanged(e.target.value);
              }}
            ></FormInputDropdown>
          );
        }}
      />
    </>
  );
};
